import React, { Component } from "react";
import Information from "../Information";
import Store from "../../../content/Store";
import Content from "../../../content/Content";
import { Paths } from "../../../constants/UrlConstants";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { setErrorMessage } from "../../../actions/error/errorActions";
import ErrorImage from "../../../assets/img/Refresh-images/ErrorImage.png";
import LOGOUT from "../../logout/Logout";
import styles from "../../../assets/css/modules/information/errors/sharedErrorContent/error-content-links.css";
// import Logout from "../../../content/header/Logout";
import { Link } from "react-router-dom";
import { ErrorContentLinks } from "./sharedErrorContent/ErrorContentLinks";
import ErrorInformation from "../ErrorInformation";
// import {errorcss} from "../../../assets/css/error.css";


export const mapStateToGenericError = ({
  accountReducer,
  networkStateReducer,
  errorReducer,
  layoutReducer

}) => {
  return {
    isTimedOut: accountReducer.isTimedOut,
    isSystemUnavailable: networkStateReducer.systemUnavailable,
    errorMessage: errorReducer.errorMessage,
    isLoggedOut: networkStateReducer.isLoggedOut,
    layout: layoutReducer.layout
  };
};

export class GenericError extends Component {
  componentDidMount() {

    if (this.props.isLoggedOut) {
      this.props.history.replace(Paths.LoggedOut);
    }
    if (this.props.isTimedOut) {
      this.props.history.replace(Paths.Timeout);
    }
    if (this.props.isSystemUnavailable) {
      this.props.history.replace(Paths.SystemUnavailable);
    }
    if(this.props.errorMessage !== null && this.props.errorMessage !== undefined && this.props.errorMessage.includes('User has exceeded the maximum number for retries')){
      this.props.history.replace(Paths.MFAIncorrectAttemptErrorPage);
    }
  }

  componentWillUnmount() {
    this.props.setErrorMessage();
  }



  render() {

    return (

      <div>
        {this.props.layout === 'MOL' ? (
          <div className="container">
        <div className={ "row container-row-generic"}>
          <div className="col-xl-7">
            <ErrorInformation headerText={Store.ErrorPages.GenericError.HeaderText}>
              <Content name={Store.ErrorPages.GenericError.Message} />
              <p name="errorMessage">{this.props.errorMessage}</p>
              <div className="row logout-generic-link">
                <div className="col-2 float-left">
                  <p className={styles.sharedErrorContent}><LOGOUT timeout="timeout"/></p>
                </div>
                <div className="col-1 float-right">
                  <Link to={Paths.LoggedOut}>
                    <Content name={Store.ErrorPages.GenericError.Link} />
                  </Link>
                </div>
              </div>
            </ErrorInformation>
          </div>
          <div className="col-md-5 col-lg-5 col-sm-5 d-none d-sm-block">
            <div className="container">
              <img className="d-none d-sm-block img" src={ErrorImage} alt="" />
            </div>
          </div>
        </div>
        </div>) : (<Information headerText={Store.ErrorPages.GenericError.HeaderText}>
          <Content name={Store.ErrorPages.GenericError.Message} />
          <p name="errorMessage">{this.props.errorMessage}</p>
          <ErrorContentLinks />
        </Information>)}
      </div>
    );
  }
}
export default withRouter(
  connect(mapStateToGenericError, { setErrorMessage })(GenericError)
);
